import { render, staticRenderFns } from "./WebinarCard.vue?vue&type=template&id=80d25b68&scoped=true&"
import script from "./WebinarCard.vue?vue&type=script&lang=js&"
export * from "./WebinarCard.vue?vue&type=script&lang=js&"
import style0 from "./WebinarCard.vue?vue&type=style&index=0&id=80d25b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d25b68",
  null
  
)

export default component.exports